(ns hypnos.consumer.routes
  "Hypnos consumer routes."
  (:require [bidi.bidi :as bidi]
            [hypnos.consumer.events]
            [pushy.core :as pushy]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def ^{:private true :const true} key-regex #"(?i)[0-9a-f]{32}")

(def ^{:const true :private true} routes
  ["/" {""                              :home-panel
        "error"                         :error-panel
        ["" [key-regex :consult-key]]   :consult-panel
        ["p/" [key-regex :consult-key]] :portrait-panel}])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- parse-url
  []
  (fn [url]
    (bidi/match-route routes url)))

(defn- dispatch-route
  [matched-route]
  (let [route        (name (:handler matched-route))
        route-params (:route-params matched-route)
        panel-name   (keyword route)]
    (rf/dispatch [:consumer/set-active-panel {:name   panel-name
                                              :params route-params}])))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn app-routes []
  (pushy/start! (pushy/pushy dispatch-route (parse-url))))
